'use strict';

var angularModule = angular.module('t2g.common.data-access.user', []);

module.exports = angularModule;

angularModule.factory('UserResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/office/:officeId/users';

  var resource = $resource(
    resourceUrl + '/:userId',
    { userId: '@_id', officeId: '@workingAt' },
    {
      delete: { method: 'DELETE' },
      update: { method: 'PUT' },
      getOne: { method: 'GET', isArray: false },
    },
  );

  return resource;
});

angularModule.factory('UserCache', function($cacheFactory) {
  return $cacheFactory('UserCache', { capacity: 20 });
});

angularModule.factory('UserModel', function($rootScope, UserResource, UserCache, UserSession) {
  return {
    get: function(callback) {
      var cachedObjects = UserCache.get('users');
      var officeId = UserSession.getOffice();

      if (typeof cachedObjects === 'undefined') {
        UserResource.query({ officeId: officeId }, function(response) {
          if (response instanceof Array) {
            UserCache.put('users', response);

            callback(null, response);
          } else {
            callback('Error: cant load object data');
          }
        });
      } else {
        callback(null, cachedObjects);
      }
    },
    save: function(user, callback) {
      if (user instanceof Object) {
        user = new UserResource(user);
      }

      user.workingAt = UserSession.getOffice();

      user.$save(
        function(response) {
          // refresh cache
          delete response.password;
          var cachedObjects = UserCache.get('users');
          cachedObjects.push(response);
          UserCache.remove('users');
          UserCache.put('users', cachedObjects);

          // inform observers
          $rootScope.$broadcast('User:save', response);
          callback(null, response);
        },
        function(error) {
          callback(error.data);
        },
      );
    },
    update: function(user, callback) {
      user.$update(
        function(response) {
          var cachedObjects = UserCache.get('users');

          for (var i = 0; i < cachedObjects.length; i++) {
            if (cachedObjects[i]._id == cachedObjects._id) {
              cachedObjects[i] = cachedObjects;
              break;
            }
          }

          UserCache.remove('users');
          UserCache.put('users', cachedObjects);

          // inform observers
          $rootScope.$broadcast('User:edit', response);
          callback(null, response);
        },
        function(error) {
          callback(error.data);
        },
      );
    },
    delete: function(user, callback) {
      if (user instanceof Object) {
        user = new UserResource(user);
      }

      user.$delete(
        function(response) {
          var cachedObjects = UserCache.get('users');

          for (var i = 0; i < cachedObjects.length; i++) {
            if (cachedObjects[i]._id == cachedObjects._id) {
              cachedObjects.splice(i, 1);
              break;
            }
          }

          UserCache.remove('users');
          UserCache.put('users', cachedObjects);

          // inform observers
          $rootScope.$broadcast('User:delete', user);
          callback(null, user);
        },
        function(error) {
          callback(error.data);
        },
      );
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/user.js